import Vue from 'vue'
import VueRouter from 'vue-router'
import Loading from '@/plugins/Loading';
import Home from "@/pages/Home";
import Details from "@/pages/Details";
import './app.scss';
import Overview from "@/pages/Overview";
import * as echarts from 'echarts/core';
import { BarChart, LineChart, GraphChart, GaugeChart } from 'echarts/charts';
import {
  TitleComponent,
  TooltipComponent,
  GridComponent,
  DatasetComponent,
  TransformComponent,
  LegendComponent,
  DataZoomComponent
} from 'echarts/components';
// 标签自动布局，全局过渡动画等特性
import { LabelLayout, UniversalTransition } from 'echarts/features';
// 引入 Canvas 渲染器，注意引入 CanvasRenderer 或者 SVGRenderer 是必须的一步
import { CanvasRenderer } from 'echarts/renderers';
import Assess from "@/pages/Assess";
import Scheme from "@/pages/Scheme";
import Recuperate from "@/pages/Recuperate";
import Nutrition from "@/pages/Nutrition";
import Nutritions from "./pages/Nutritions";
import Tissue from "./pages/Tissue";
import Compare from "./pages/Compare";
import Condition from "./pages/Condition";

Vue.config.productionTip = false;
// 启用路由
Vue.use(VueRouter);
// 启用加载插件
Vue.use(Loading);

// 注册必须的组件
echarts.use([
  TitleComponent,
  TooltipComponent,
  GridComponent,
  DatasetComponent,
  TransformComponent,
  BarChart,
  LineChart,
  GraphChart,
  GaugeChart,
  LabelLayout,
  UniversalTransition,
  CanvasRenderer,
  LegendComponent,
  DataZoomComponent
]);
// 启用 echarts
Vue.prototype.$echarts = echarts;

// 路由管理
const routes = [
  // 首页
  { path: '/', component: Home, meta:{ index: 0 } },
  // 全部数据概览页面
  { path: '/overview', component: Overview, meta:{ index: 2 } },
  // 调理状态评估页
  { path: '/assess', component: Assess, meta:{ index: 2 } },
  // 调理方案页
  { path: '/scheme', component: Scheme, meta:{ index: 2 } },
  // 单项详情页
  { path: '/details', component: Details, meta:{ index: 3 } },
  // 调理详情页
  { path: '/recuperate', component: Recuperate, meta:{ index: 3 } },
  // 营养素
  { path: '/nutritions', component: Nutritions, meta:{ index: 2 } },
  // 营养素单项详情
  { path: '/nutrition', component: Nutrition, meta:{ index: 3 } },
  // 身体内脏
  { path: '/tissue', component: Tissue, meta:{ index: 3 } },
  // 健康评估比对
  { path: '/compare', component: Compare, meta:{ index: 3 } },
  // 调理方案
  { path: '/condition', component: Condition, meta:{ index: 3 } },
];

// 启动应用
new Vue({
  // 加载全局路由
  router: new VueRouter({
    routes
  }),
  // 直接在页面上渲染路由视图
  render: h => h('router-view')
}).$mount('#app');
